import electron from 'electron';

import { ELECTRON_EVENTS } from '~/main/namespace';

import type { Store } from '@reduxjs/toolkit';

export function replayActionMain(store: Store) {
  if (typeof window !== 'undefined') {
    return;
  }

  electron.ipcMain.on(ELECTRON_EVENTS.REDUX_ACTION, (_: Event, payload) => {
    store.dispatch(payload);
  });
}
